import { formElement } from "../../forms/FormElement";
import ProtectiveEquipmentFormState from "../../forms/Permits/Conditions/ProtectiveEquipmentFormState";
import GasWarner from "./GasWarner";

export type ProtectiveEquipment = {
    usingLifeJacket: boolean;
    usingHelmet: boolean;
    usingProtectiveGlasses: boolean;
    gasWarner: GasWarner;
    usingGasMask: boolean;
    usingFreshAirMask: boolean;
    other: string;
};

export default ProtectiveEquipment;

export function ProtectiveEquipment_toFormState(
    protectiveEquipment: ProtectiveEquipment
): ProtectiveEquipmentFormState {
    return {
        usingLifeJacket: formElement(protectiveEquipment.usingLifeJacket),
        usingHelmet: formElement(protectiveEquipment.usingHelmet),
        usingProtectiveGlasses: formElement(protectiveEquipment.usingProtectiveGlasses),
        gasWarner: {
            forH2S: formElement(protectiveEquipment.gasWarner.forH2S),
            forLEL: formElement(protectiveEquipment.gasWarner.forLEL),
            forO2: formElement(protectiveEquipment.gasWarner.forO2),
            personalGasWarner: formElement(protectiveEquipment.gasWarner.personalGasWarner)
        },
        usingGasMask: formElement(protectiveEquipment.usingGasMask),
        usingFreshAirMask: formElement(protectiveEquipment.usingFreshAirMask),
        other: formElement(protectiveEquipment.other)
    };
}
